export default {
  isOnlyUser(state) {
    return state.user && state.user.roleName === 'onlyData';
  },
  isLogged(state) {
    return state.user && state.user.roleId > 0;
  },
  invoicesPermission(state) {
    return state.acl && state.acl.invoices;
  },
  reportsPermission(state) {
    return state.acl && state.acl.reports;
  },
  addAddressPermission(state) {
    return state.acl && state.acl.createAddress;
  },
  showNetPrices(state) {
    return state.acl && state.acl.showNetPrices;
  },
  defaultCostCenter(state) {
    return state.user.defaultCostCenter && state.user.defaultCostCenter;
  },
  eInvoiceEnabled(state) {
    return state.acl && state.acl.eInvoiceEnabled;
  },
  allowedToChangeEInvoiceSetting(state) {
    return state.acl && state.acl.allowedToChangeEInvoiceSetting;
  },
  showChangeEInvoiceCheckout(state) {
    return state.acl && state.acl.allowedToChangeEInvoiceSetting && !state.acl.eInvoiceEnabled;
  },
  hasBlockedPromotions(state) {
    return state.acl && state.acl.hasBlockedPromotions;
  },
  subscribedToNewsletter(state) {
    return state.acl && state.acl.subscribedToNewsletter;
  },
  isTrackingCookies(state) {
    return state.acl && state.acl.agreedToTrackingCookies;
  },
  isCompanyAccount(state) {
    return state.company && 'taxId' in state.company && state.company.taxId;
  },
  isCompanyCustomer(state) {
    return (
      state.company && 'isPrivateCustomer' in state.company && !state.company.isPrivateCustomer
    );
  },
  isPrivateCustomer(state) {
    return state.company && 'isPrivateCustomer' in state.company && state.company.isPrivateCustomer;
  },
  hasOffer(state) {
    return state.company && 'hasOffer' in state.company && state.company.hasOffer;
  },
  hasCatalogSubset(state) {
    return !!state.acl.catalogSubsetType;
  },
  getPermissions(state, getters) {
    return {
      catalogSubsets: getters.hasCatalogSubset,
    };
  },
};
